import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  root: {
    padding: '32px 79px 37px 79px',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  searchInput: {
    border: '1px solid #ccc',
    marginTop: '5px',
  },
  buttonWrapper: {
    maxWidth: '285px',
    marginTop: '5px',
  },
  addButton: {
    width: '285px',
    fontSize: 17,
  },
}));
